import { Link } from 'react-router-dom'
import logo from '../../assets/Myrin-transparent.webp'


import { ArrowUpRight, Facebook, Instagram, Linkedin, Mail, MapPin, Phone, Twitter, Youtube } from 'lucide-react'

const WhatsappIcon = ({ size = 24 }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
        <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 0 1-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 0 1-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 0 1 2.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0 0 12.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 0 0 5.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 0 0-3.48-8.413Z" />
    </svg>
)

const Footer = () => {
    const year = new Date().getFullYear()
    const appName = import.meta.env.VITE_APP_NAME || 'KSDPL'

    return (
        <footer className="site-footer">
            <div className="container footer__inner">
                <div className="footer__brand">
                    <Link to="/" className="footer__logo-link">

                        <img src={logo} alt="Kanchaneshver Sales and Distribution Private Limited" className="footer__logo" />
                    </Link>
                    <p className="footer__intro">
                        Smart SaaS tools for DSA teams, sales operations, lead tracking, and customer growth.
                    </p>
                    <div className="footer__badges">
                        <span>Lead Management</span>
                        <span>DSA Growth</span>
                        <span>Automation</span>
                    </div>
                </div>

                <nav className="footer__links-panel" aria-label="Footer navigation">
                    <h4>Explore</h4>
                    <div className="footer__links-grid">
                       <Link to="/">Home <ArrowUpRight size={14} /></Link>
                        <Link to="/about">About <ArrowUpRight size={14} /></Link>
                        <Link to="/services">Services <ArrowUpRight size={14} /></Link>
                        <Link to="/contact">Contact <ArrowUpRight size={14} /></Link>

                    </div>
                </nav>

                <div className="footer__contact-panel">
                    <h4>Contact</h4>
                    <a href="tel:+9201963018" className="footer__contact-link">
                        <Phone size={17} />
                        <span>9201963018</span>
                    </a>
                    <a href="mailto:info@myrinbazaar.com" className="footer__contact-link">
                        <Mail size={17} />
                        <span>info@myrinbazaar.com</span>
                    </a>
                    <a href="https://maps.app.goo.gl/RqDMHkJz3kCu9ku98" target="_blank" rel="noreferrer" className="footer__contact-link footer__contact-link--address">
                        <MapPin size={17} />
                        <span>Office No. 109, 110, C21 Mall, Nanakheda Bus Stand, Ujjain, Madhya Pradesh - 456010</span>
                    </a>
                </div>
            </div>

                     <div className="container footer__bottom">
    <div className="footer__policy-links">
        <Link to="/terms-and-conditions" target="_blank">Terms</Link>
<Link to="/privacy-policy" target="_blank">Privacy</Link>
<Link to="/refund-policy" target="_blank">Refund</Link>
<Link to="/desclaimer" target="_blank">Disclaimer</Link>

    </div>

    <div className="footer__legal">
        <p>Copyright {year} &copy; <Link to="/">{appName}</Link></p>
        <div className="footer__powered">
            <span>Powered by MyRinBazaar Consultancy Private limited</span>
            <img src={logo} alt="MyRinBazaar Consultancy Private Limited" className="footer__powered-logo" loading="lazy" />
        </div>
    </div>


    <div className="social-container">
        <a href="https://www.facebook.com/share/1ByTzFyVAJ/" target="_blank" rel="noreferrer" aria-label="Facebook"><Facebook size={17} /></a>
        <a href="https://www.instagram.com/myrin_bazaar/?hl=en" target="_blank" rel="noreferrer" aria-label="Instagram"><Instagram size={17} /></a>
        <a href="https://www.linkedin.com/company/myrinbazaar/" target="_blank" rel="noreferrer" aria-label="LinkedIn"><Linkedin size={17} /></a>
        <a href="https://x.com/MyRinBazaar" target="_blank" rel="noreferrer" aria-label="X (Twitter)"><Twitter size={17} /></a>
        <a href="https://www.youtube.com/@MyRinBazaar" target="_blank" rel="noreferrer" aria-label="YouTube"><Youtube size={17} /></a>
        <a href="https://whatsapp.com/channel/0029Vb8gncHId7nIoWYDLn0z" target="_blank" rel="noreferrer" aria-label="WhatsApp Channel"><WhatsappIcon size={17} /></a>
    </div>
</div>
        </footer>

    )
}


export default Footer
